// Prevent duplicate declaration
if (typeof DiscountPopup === 'undefined') {
    window.DiscountPopup = class DiscountPopup {
      constructor() {
        this.klaviyoFormId = 'WHDs37'; // Confirm this ID in Klaviyo Signup Forms
  
        this.overlay = document.getElementById('discount-popup-overlay');
        this.closeBtn = document.querySelector('.discount-popup__close');
        this.form = document.getElementById('discount-form');
        this.floatingButton = document.querySelector('.floating-discount-button');
  
        this.init();
      }
  
      init() {
        // Collect all possible popup triggers without duplicating event listeners
        const triggers = new Set([
          ...document.querySelectorAll('.discount-popup-trigger'),
          ...document.querySelectorAll('[data-popup-trigger]'),
          ...document.querySelectorAll('.floating-discount-button'),
          ...document.querySelectorAll('.discount-banner--title-button')
        ]);
  
        triggers.forEach((trigger) => {
          trigger.addEventListener('click', (e) => {
            e.preventDefault();
  
            this.hideFloatingButton();
            this.openKlaviyoPopup();
          });
        });
  
        // Optional: keep custom popup close behavior in case the old popup is still rendered somewhere
        if (this.closeBtn) {
          this.closeBtn.addEventListener('click', () => {
            this.closePopup();
          });
        }
  
        // Optional: close old custom popup on overlay click, if still present
        if (this.overlay) {
          this.overlay.addEventListener('click', (e) => {
            if (e.target === this.overlay) {
              this.closePopup();
            }
          });
        }
  
        // Optional: close old custom popup with Escape, if still present
        document.addEventListener('keydown', (e) => {
          if (e.key === 'Escape' && this.isOpen()) {
            this.closePopup();
          }
        });
  
        // Important:
        // We are NOT calling checkPopupDisplay() anymore because that would auto-open
        // the old custom discount popup instead of the Klaviyo popup.
  
        this.hideFloatingButton();
      }
  
      openKlaviyoPopup() {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', this.klaviyoFormId]);
      }
  
      // Old custom popup methods kept only as fallback
      openPopup(openedByFloatingButton = false) {
        if (this.overlay) {
          this.overlay.classList.add('active');
          document.body.style.overflow = 'hidden';
          this.overlay.style.display = 'flex';
  
          this.openedByFloatingButton = openedByFloatingButton;
  
          const emailInput = this.overlay.querySelector('.discount-email-input');
          if (emailInput) {
            setTimeout(() => emailInput.focus(), 100);
          }
        }
      }
  
      closePopup() {
        if (this.overlay) {
          this.overlay.classList.remove('active');
          document.body.style.overflow = '';
  
          setTimeout(() => {
            this.overlay.style.display = 'none';
            this.showFloatingButton();
            this.openedByFloatingButton = false;
          }, 300);
        }
      }
  
      isOpen() {
        return this.overlay && this.overlay.classList.contains('active');
      }
  
      hideFloatingButton() {
        if (this.floatingButton) {
          this.floatingButton.classList.remove('visible');
  
          setTimeout(() => {
            this.floatingButton.style.display = 'none';
          }, 500);
        }
      }
  
      showFloatingButton() {
        if (this.floatingButton) {
          this.floatingButton.style.display = 'flex';
  
          setTimeout(() => {
            this.floatingButton.classList.add('visible');
          }, 50);
        }
      }
    };
  }
  
  // Initialize when DOM is loaded only once
  if (!window.discountPopupInitialized) {
    document.addEventListener('DOMContentLoaded', () => {
      try {
        if (window.DiscountPopup) {
          new window.DiscountPopup();
          window.discountPopupInitialized = true;
        }
      } catch (error) {
        console.error('Error initializing DiscountPopup:', error);
      }
    });
  }